import { render } from "./HomeInicio.vue?vue&type=template&id=569176e4&scoped=true"
import script from "./HomeInicio.vue?vue&type=script&lang=js"
export * from "./HomeInicio.vue?vue&type=script&lang=js"

import "./HomeInicio.vue?vue&type=style&index=0&id=569176e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569176e4"]])

export default __exports__